import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {AddressInput, ButtonMain, SelectMain} from "components";
import {AllStatusesEnum, LegTypesEnum} from "fragments";
import {AddFacility} from "../../facilities";
import {facilitiesActions} from 'store'
import {dontAllowChangesLegStatuses, isEmptyObj, usePrimaryModal, useSecondaryModal} from "utils";
import {Svg} from "assets";
import axios from "axios";

export const AddAddress = ({
                               address,
                               facility,
                               setValue,
                               currentPath,
                               currentFacilityPath,
                               clearErrors,
                               type,
                               legs,
                               originalPath,
                               facilityPath
                           }) => {
    const [getFacilityLoading, setFacilityLoading] = useState(false)
    const {facilitiesList} = useSelector((state) => ({
        facilitiesList: state.facilities?.facilitiesList
    }))
    const dispatch = useDispatch();
    const {control, getValues, setValue: setValueAddress, watch, handleSubmit} = useForm();
    const {closePrimary} = usePrimaryModal();
    const {openSecondary, closeSecondary} = useSecondaryModal();
    const currentFacility = watch(currentFacilityPath);


    const getFacilities = () => {
        const params = {
            status: AllStatusesEnum.ACTIVE,
        };
        dispatch(facilitiesActions.getFacilities(params));
        closeSecondary()
    }


    useEffect(() => {
        getFacilities()
    }, [])


    useEffect(() => {
        if (facility) {
            setValueAddress(currentFacilityPath, facilitiesList?.facilities?.find((singleFacility) => singleFacility?.id === facility));
        }
    }, [facility])

    useEffect(() => {
        if (!isEmptyObj(address)) {
            setValueAddress('address', address);
        }
    }, [address])

    useEffect(() => {
        if (currentFacility?.address) {
            setValueAddress('address', currentFacility?.address);
        }
    }, [currentFacility])


    const customAddFacilityRequest = async (data) => {
        try {
            setFacilityLoading(true)
            const res = await axios.post("/facilities", data, {auth: true});
            const params = {};
            dispatch(facilitiesActions.getFacilities(params));
            setValueAddress(currentFacilityPath, res?.data)
            closeSecondary()
        } catch (e) {
        } finally {
            setFacilityLoading(false)
        }
    }

    const addFacility = (item) => {
        openSecondary(
            <AddFacility
                info={item}
                onCancel={() => closeSecondary()}
                closeModal={closeSecondary}
                customAddRequest={customAddFacilityRequest}
            />, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 610
            });
    };

    const changeAddress = (data) => {
        if (isEmptyObj(data?.address)) {
            closePrimary();
            return;
        }

        const typeMap = {
            [LegTypesEnum.APPOINTMENT]: {
                dropOffAddress: [
                    [LegTypesEnum.APPOINTMENT, 'dropOffAddress'],
                    [LegTypesEnum.RETURN, 'pickupAddress'],
                ],
                pickupAddress: [
                    [LegTypesEnum.APPOINTMENT, 'pickupAddress'],
                    [LegTypesEnum.RETURN, 'dropOffAddress'],
                    [LegTypesEnum.ESCORT_PICKUP, 'dropOffAddress'],
                    [LegTypesEnum.ESCORT_DROPOFF, 'pickupAddress'],
                ],
            },
            [LegTypesEnum.ESCORT_PICKUP]: {
                pickupAddress: [
                    [LegTypesEnum.ESCORT_PICKUP, 'pickupAddress'],
                    [LegTypesEnum.ESCORT_DROPOFF, 'dropOffAddress'],
                ],

                dropOffAddress: [
                    [LegTypesEnum.ESCORT_PICKUP, 'dropOffAddress'],
                    [LegTypesEnum.ESCORT_DROPOFF, 'pickupAddress'],
                ],
            },
            [LegTypesEnum.MED_DROP]: {
                pickupAddress: [
                    [LegTypesEnum.MED_DROP, 'pickupAddress'],
                    [LegTypesEnum.MED_DROP_RETURN, 'dropOffAddress'],
                ],

                dropOffAddress: [
                    [LegTypesEnum.MED_DROP, 'dropOffAddress'],
                    [LegTypesEnum.MED_DROP_RETURN, 'pickupAddress'],
                ],
            },
            [LegTypesEnum.BUS_ROUTE]: {
                pickupAddress: [
                    [LegTypesEnum.BUS_ROUTE, 'pickupAddress'],
                    [LegTypesEnum.BUS_ROUTE_RETURN, 'dropOffAddress'],
                ],

                dropOffAddress: [
                    [LegTypesEnum.BUS_ROUTE, 'dropOffAddress'],
                    [LegTypesEnum.BUS_ROUTE_RETURN, 'pickupAddress'],
                ],
            },
        };

        const mappings = typeMap[type]?.[originalPath];

        if (mappings) {
            const updatedLegs = legs?.map((leg) => {
                const match = mappings.find(([legType]) => leg.type === legType);

                return (match && (leg?.status && !dontAllowChangesLegStatuses(leg?.status)))
                    ? {...leg, [match[1]]: data.address, [facilityPath]: currentFacility?.id}
                    : leg;
            });
            setValue('legs', updatedLegs, {shouldDirty: true});
            closePrimary();
            return;
        }

        if (setValue && currentPath) {
            setValue(currentPath, data.address, {shouldDirty: false});
            clearErrors(currentPath);
            if (currentFacilityPath)
                setValue(currentFacilityPath, currentFacility?.id, {shouldDirty: false});
        }

        closePrimary();
    };


    // const changeAddress = (data) => {
    //     const address = data?.address;
    //
    //     if (!isEmptyObj(address)) {
    //         let updatedLegs = [...legs];
    //
    //         const updateLegsByType = (updates) => {
    //             updatedLegs = legs.map((leg) => {
    //                 const updater = updates[leg.type];
    //                 return updater ? updater(leg) : leg;
    //             });
    //             setValue('legs', updatedLegs, { shouldDirty: true });
    //         };
    //
    //         if (type === LegTypesEnum.APPOINTMENT) {
    //             if (originalPath === 'dropOffAddress') {
    //                 updateLegsByType({
    //                     [LegTypesEnum.APPOINTMENT]: leg => ({
    //                         ...leg,
    //                         dropOffAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                     [LegTypesEnum.RETURN]: leg => ({
    //                         ...leg,
    //                         pickupAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                 });
    //             } else if (originalPath === 'pickupAddress') {
    //                 updateLegsByType({
    //                     [LegTypesEnum.APPOINTMENT]: leg => ({
    //                         ...leg,
    //                         pickupAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                     [LegTypesEnum.RETURN]: leg => ({
    //                         ...leg,
    //                         dropOffAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                     [LegTypesEnum.ESCORT_PICKUP]: leg => ({
    //                         ...leg,
    //                         dropOffAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                     [LegTypesEnum.ESCORT_DROPOFF]: leg => ({
    //                         ...leg,
    //                         pickupAddress: address,
    //                         [facilityPath]: currentFacility?.id,
    //                     }),
    //                 });
    //             }
    //         } else if (
    //             type === LegTypesEnum.ESCORT_PICKUP &&
    //             originalPath === 'pickupAddress'
    //         ) {
    //             updateLegsByType({
    //                 [LegTypesEnum.ESCORT_PICKUP]: leg => ({
    //                     ...leg,
    //                     pickupAddress: address,
    //                     [facilityPath]: currentFacility?.id,
    //                 }),
    //                 [LegTypesEnum.ESCORT_DROPOFF]: leg => ({
    //                     ...leg,
    //                     dropOffAddress: address,
    //                     [facilityPath]: currentFacility?.id,
    //                 }),
    //             });
    //         } else if (setValue && currentPath) {
    //             setValue(currentPath, address, { shouldDirty: false });
    //             clearErrors(currentPath);
    //
    //             if (setValue && currentFacilityPath) {
    //                 setValue(currentFacilityPath, currentFacility, { shouldDirty: false });
    //             }
    //         }
    //     }
    //     closePrimary();
    // };

    return (
        <form className='add-address-wrapper' onSubmit={handleSubmit(changeAddress)}>
            <div className="modal-header-main">
                <h3 className="modal-header-title">Change Address</h3>

                <button className="modal-close-btn-main" type="button" onClick={closePrimary}>
                    <Svg.CloseSvg/>
                </button>
            </div>
            <div className="modal-body-main">
                <SelectMain
                    name={currentFacilityPath}
                    labelHeader='Facility'
                    list={facilitiesList?.facilities}
                    renderLabel={(option) => option?.name}
                    control={control}
                    placeholder="Select Facility"
                    loadType="GET_FACILITIES"
                    loading={getFacilityLoading}
                    CustomLastElement={
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }
                            }
                            className='add-new-facility-btn-wrapper-in-select'
                        >
                            <button
                                className="add-new-facility-btn-in-select"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    addFacility();
                                }
                                }
                            >
                                <Svg.PlusSvg/>
                                Add New Facility
                            </button>
                        </div>
                    }
                />

                <AddressInput
                    control={control}
                    allValues={getValues()?.address}
                    setValue={setValueAddress}
                    required
                />
            </div>
            <div className="modal-footer-main">
                <ButtonMain
                    type='button'
                    text="Cancel"
                    cancel
                    buttonMainStyles={{
                        width: "fit-content",
                    }}
                    onClick={closePrimary}
                />
                <ButtonMain
                    text={address?.formattedAddress ? 'Change' : 'Save'}
                    load={''}
                    type='submit'
                    buttonMainStyles={{
                        width: "80px",
                    }}
                />
            </div>
        </form>

    );
};

